"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _button = _interopRequireDefault(require("@ingka/button"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const ModalFooter = ({
  prefix,
  children,
  closeBtnClick,
  compact,
  renderBorder,
  className
}) => {
  const footerRef = _react.default.useRef();

  const testClientSize = () => footerRef.current ? Number(footerRef.current.getBoundingClientRect().width) < 600 : false;

  const pendingUpdateID = _react.default.useRef();

  const [smallScreen, setSmallscreen] = _react.default.useState(testClientSize());

  const debouncedResize = () => {
    clearTimeout(pendingUpdateID.current);
    pendingUpdateID.current = setTimeout(() => setSmallscreen(testClientSize()), 40);
  };

  const childrenArr = _react.default.Children.toArray(children);

  _react.default.useEffect(() => {
    if (compact && childrenArr.length) {
      window.addEventListener('resize', debouncedResize);
    }

    return () => window.removeEventListener('resize', debouncedResize);
  }, [compact, children]);

  _react.default.useLayoutEffect(() => {
    setSmallscreen(testClientSize());
  }, [compact, children]);

  const classes = (0, _classnames.default)(`${prefix}modal-footer`, compact && `${prefix}modal-footer--compact`, !renderBorder && `${prefix}modal-footer--borderless`, className);
  return _react.default.createElement("div", {
    className: classes,
    ref: footerRef
  }, childrenArr.map((item, i) => {
    const clickHandlerWrapper = item.props.onClick ? ev => item.props.onClick(ev, closeBtnClick) : () => closeBtnClick();
    return _react.default.cloneElement(item, {
      prefix,
      key: i,
      onClick: clickHandlerWrapper,
      small: compact && smallScreen && childrenArr.length > 1
    });
  }));
};

ModalFooter.defaultProps = {
  prefix: '',
  compact: false,
  renderBorder: true
};
var _default = ModalFooter;
exports.default = _default;